import { FC } from 'react';
import { Navigate } from 'react-router-dom';

export const InvestorProfilePage: FC = () => (
  <Navigate to="/profile?tab=investor" replace />
);
